import React, {useState} from "react";
import {EmblemExperiencesList} from "../services/EmblemServices";
import {ListByEmblem, DeleteCourse} from "../services/CoursesServices";

export const EmblemContext = React.createContext({});

export default function EmblemProvider({children}) {
   const [experiencesList, setExperiences] = useState([]);
   const [isSaving, setSaving] = useState(false);

   const getExperiences = () => {
      ListByEmblem()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setExperiences(data);
         })
         .catch((e) => {
            console.log(e);
         });
   };

   const dlExperiences = (id) => {
      setSaving(true);
      DeleteCourse(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            const newData = experiencesList.filter((item) => item.idCourse !== id);
            setExperiences(newData);
            setSaving(false);
         })
         .catch((e) => {
            setSaving(false);
            console.log(e);
         });
   };

   const toggleExperiences = (val, target, key) => {
      const newData = experiencesList.map((item) => {
         if (item.id === key) {
            return {...item, [target]: val};
         }
         return item;
      });
      setExperiences(newData);
   };

   return (
      <EmblemContext.Provider
         value={{experiencesList: experiencesList, getExperiences: getExperiences, dlExperiences, toggleExperiences, isSaving}}
      >
         {children}
      </EmblemContext.Provider>
   );
}

const datExample = [
   {
      id: 1,
      name: "Programa Emblem",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: false,
      onhome: false,
      hours: "3 horas",
   },
   {
      id: 2,
      name: "Programa Emblem",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: true,
      onhome: true,
      hours: "3 horas",
   },
   {
      id: 4,
      name: "Programa Emblem 2",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: false,
      onhome: false,
      hours: "3 horas",
   },
   {
      id: 6,
      name: "Programa Emblem Alfa",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: false,
      onhome: false,
      hours: "3 horas",
   },
   {
      id: 8,
      name: "Programa Emblem B",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: true,
      onhome: false,
      hours: "3 horas",
   },
];
